import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Uom1Service {

  localAppUrl = environment.localApiUrl;
 
  constructor(private http: HttpClient) { }

  getAllMeasurements(): Observable<any> {
    return this.http.get<any>(`${environment.inventoryURl}UOMDetail`);
  }

  getBaseUOM(typeId,parentBaseUOMId,baseUOMId) {
    return this.http.get<any>(`${environment.inventoryURl}UOMBase?typeId=${typeId}&isParent=${parentBaseUOMId}&baseUOMId=${baseUOMId}`);
  }

  deleteUOM(id) {
    return this.http.delete<any>(`${environment.inventoryURl}UOMDetail/${id}`)
    .toPromise()
    .then(res => res);
  }

  getInventoryGroupList() {
    return this.http.get<any>(`${environment.inventoryURl}Group`);
  }

  
  getInventoryCategory(id) {
    return this.http.get<any>(`${environment.inventoryURl}Category?groupId=${id}`);
  }

  addUOM(data) {
    return this.http.post<any>(`${environment.inventoryURl}UOMDetail/AddMultipleUOMDetail`,data)
    .toPromise()
    .then(res => res);
  }

  updateUOM(data) {
    return this.http.put<any>(`${environment.inventoryURl}UOMDetail`,data)
    .toPromise()
    .then(res => res);
  }

  getAllBaseUom() {
    return this.http.get<any>(this.localAppUrl + 'allBaseUom')
      .toPromise()
      .then(res => res);
  }
  addBaseUom(c) {
    return this.http.post<any>(this.localAppUrl + 'allBaseUom', c)
        .toPromise()
        .then(res => res);
  }
  editBaseUom(c) {
      return this.http.put<any>(this.localAppUrl + 'allBaseUom', c)
          .toPromise()
          .then(res => res);
  }
  deleteBaseUom(id) {
      return this.http.delete<any>(this.localAppUrl + 'allBaseUom/' + id)
          .toPromise()
          .then(res => res);
  }

  addNewBaseUOM(data) {
    return this.http.post<any>(`${environment.inventoryURl}UOMBase`,data)
    .toPromise()
    .then(res => res);
  }

  checkAssociateUOM(id) {
    return this.http.get<any>(`${environment.inventoryURl}UOMDetail/CheckUOMProductAssociation?uomId=${id}`);
  }
}
